import { render, staticRenderFns } from "./AuctionHeader.vue?vue&type=template&id=26141e50"
import script from "./AuctionHeader.vue?vue&type=script&lang=js"
export * from "./AuctionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports